/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { useTranslation } from "react-i18next";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";
import defineConf from "../../../config/defineConf";
import "../layout/DataGridAgreementRsltColumn.css";

function DataGridAgreementRsltColumn(props) {
    const { schema, ...others } = props;

    const [cellTemplate, setCellTemplate] = useState((ctx) => {
        return <></>;
    });

    const { t } = useTranslation();

    useEffect(() => {
        setCellTemplate(() => (ctx) => {
            if (ctx.item[schema.name]) {
                const agreementRslt = ctx.item[schema.name];

                switch (agreementRslt) {
                    case defineConf.agreementRslt.AGREEMENT_COMPLETED:
                        return <span className="agreement-completed">{t(`selectItems.agreementRslt.completed`)}</span>;

                    case defineConf.agreementRslt.AGREEMENT_DENIED:
                        return <span className="agreement-denied">{t(`selectItems.agreementRslt.denied`)}</span>;

                    case defineConf.agreementRslt.AGREEMENT_CANCELED:
                        return <span className="agreement-canceled">{t(`selectItems.agreementRslt.canceled`)}</span>;

                    default:
                        return <span>{t(`selectItems.agreementRslt.none`)}</span>;
                }
            } else {
                return <span>{t(`selectItems.agreementRslt.none`)}</span>;
            }
        });
    }, [schema]);

    return (
        <DataGridColumn schema={schema} {...others}>
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>
    );
}

export default DataGridAgreementRsltColumn;
